function init(field)
{
  const input = field.querySelector("input, textarea");

  input.addEventListener("focus", e => void field.classList.add("focused"));
  input.addEventListener("blur", e => void field.classList.remove("focused"));
  input.addEventListener("input", e => {
    field.classList.remove("error");
    field.classList.toggle("filled", input.value.length);
  });

  field.classList.toggle("filled", input.value.length);
}

export { init };
